import { render, staticRenderFns } from "./ModalDealerAdd.vue?vue&type=template&id=4ffd2caa&scoped=true"
import script from "./ModalDealerAdd.vue?vue&type=script&lang=js"
export * from "./ModalDealerAdd.vue?vue&type=script&lang=js"
import style0 from "./ModalDealerAdd.vue?vue&type=style&index=0&id=4ffd2caa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffd2caa",
  null
  
)

export default component.exports